import { MatchingQueueActionTypes } from "../types";
import { IWorkflowItemStep, SearchQueuePagedRequest } from "../../../../common/sharedTypes";
import Api from "../../../../services/Api";
import { ApiResponse } from "apisauce";
import {
  IMatchingQueuePagedResult,
  IMatchingSearchResponse,
  IMatchingSearchResult,
  ISearchMatchingQueuePagedResponse,
  PartialMatchQueueItem,
} from "../business-objects/common";
import { toast } from "react-toastify";

export const getPartialMatches = async (
  url: string,
  request: SearchQueuePagedRequest
): Promise<ApiResponse<ISearchMatchingQueuePagedResponse>> => {
  return await Api.post(url, request);
};

export const searchPartialMatchesPaged = (url: string, request: SearchQueuePagedRequest) => {
  return async (dispatch) => {
    try {
      dispatch(setLoadingWorkflowSteps(true));
      await getPartialMatches(url, request).then(
        (response: ApiResponse<ISearchMatchingQueuePagedResponse>) => {
          dispatch(reducePagedResults(response.data.results));
          dispatch(setTotalWorkflowSteps(response.data.totalResults));
        }
      );
    } catch (ex) {
      console.log(ex);
    } finally {
      dispatch(setLoadingWorkflowSteps(false));
    }
  };
};

export const searchPartialMatches = (url: string) => {
  return async (dispatch) => {
    try {
      await Api.get(url).then((response: ApiResponse<IMatchingSearchResponse>) => {
        dispatch(reduceResults(response.data.results));
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};
export const reduceResults = (results: IMatchingSearchResult[]) => {
  return {
    type: MatchingQueueActionTypes.SEARCH_PARTIAL_MATCHES,
    value: results,
  };
};

export const reducePagedResults = (results: IMatchingQueuePagedResult[]) => {
  return {
    type: MatchingQueueActionTypes.SEARCH_PARTIAL_MATCHES_PAGED,
    value: results,
  };
};

export const openMerge = (workflowItemStep: IWorkflowItemStep) => {
  return async (dispatch) => {
    await dispatch(view(workflowItemStep));
    return Promise.resolve(workflowItemStep);
  };
};
export const view = (workflowItemStep: IWorkflowItemStep) => {
  return {
    type: MatchingQueueActionTypes.OPEN_REPORT,
    value: workflowItemStep,
  };
};

export const cancelMerge = (url, keywordsId: number, workflowItemStepId: number) => {
  return async (dispatch) => {
    try {
      await Api.post(url, {
        keywordsId: keywordsId,
        workflowItemStepId: workflowItemStepId,
      }).then((result: ApiResponse<any>) => {
        dispatch(reduceCancel(result.data));
        return Promise.resolve(result.data);
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};

export const reduceCancel = (itemStep: IWorkflowItemStep) => {
  return {
    type: MatchingQueueActionTypes.CANCEL_MERGE,
    value: itemStep,
  };
};

export const assignAndOpen = (
  url: string,
  stepItemId: number,
  keywordsIdToMerge: number,
  assignToId: number
) => {
  return async (dispatch) => {
    try {
      await Api.post(url, {
        workflowStepItemId: stepItemId,
        mergeWithKeywordsId: keywordsIdToMerge,
        assignToUserId: assignToId,
      }).then((result: ApiResponse<any>) => {
        dispatch(reduceAssignAndOpen(result.data));
        if (result.data == null) {
          toast.error("Report already assigned");
          return Promise.reject(result.data);
        }
        return Promise.resolve(result.data);
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};

export const reduceAssignAndOpen = (itemStep: IWorkflowItemStep) => {
  return {
    type: MatchingQueueActionTypes.ASSIGN_AND_OPEN_REPORT,
    value: itemStep,
  };
};

export const unAssign = (url: string, stepItem: IWorkflowItemStep | PartialMatchQueueItem) => {
  return async (dispatch) => {
    try {
      await Api.post(url, {
        workflowStepItemId: stepItem.id,
      }).then((result: ApiResponse<any>) => {
        dispatch(reduceUnAssign(result.data));
        return Promise.resolve(result.data);
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};
export const reduceUnAssign = (itemStep: IWorkflowItemStep) => {
  return {
    type: MatchingQueueActionTypes.UNASSIGN,
    value: itemStep,
  };
};

export const markAsNew = (url: string, stepItem: IWorkflowItemStep | PartialMatchQueueItem) => {
  return async (dispatch) => {
    try {
      await Api.post(url, {
        workflowStepItemId: stepItem.id,
      }).then((result: ApiResponse<any>) => {
        if (result.ok) {
          dispatch(reduceMarkAsNew(result.data));
          return Promise.resolve(result.data);
        } else {
          console.log(result);
          return Promise.reject("Bad Response");
        }
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};
export const reduceMarkAsNew = (itemStep: IWorkflowItemStep) => {
  return {
    type: MatchingQueueActionTypes.MARK_AS_NEW,
    value: itemStep,
  };
};

export const completeMerge = (url: string, itemStep: IWorkflowItemStep, assignNext: boolean) => {
  return async (dispatch) => {
    try {
      await Api.post(url, {
        workflowItemStepId: itemStep.id,
        assignNext: assignNext,
      }).then((result: ApiResponse<any>) => {
        if (result.ok) {
          dispatch(reduceComplete(result.data));
          return Promise.resolve(result.data);
        } else {
          console.log(result);
          return Promise.reject("Bad Response");
        }
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};
export const reduceComplete = (nextItemStep: IWorkflowItemStep) => {
  return {
    type: MatchingQueueActionTypes.COMPLETE_MERGE,
    value: nextItemStep,
  };
};

export const doAutoMerge = (
  url: string,
  reportId1: number,
  reportId2: number,
  workflowItemStepId: number
) => {
  return async (dispatch) => {
    try {
      await Api.post(url, {
        reportId1,
        reportId2,
        workflowItemStepId,
      }).then((result: ApiResponse<any>) => {
        //dispatch(reduceAutoMerge(result.data));
        if (result.ok) return Promise.resolve(result.data);
        else {
          return Promise.reject(result.data.Message);
        }
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};
// export const reduceAutoMerge = (nextItemStep: IWorkflowItemStep) => {
//   return {
//     type: MatchingQueueActionTypes.COMPLETE_MERGE,
//     value: nextItemStep,
//   };
// };
export const sendToManagement = (url: string, workflowItemStepId: number) => {
  return async (dispatch) => {
    try {
      await Api.post(url, {
        workflowItemStepId: workflowItemStepId,
      }).then((result: ApiResponse<any>) => {
        dispatch(reducesendToManagement(workflowItemStepId));
        return Promise.resolve(result.data);
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};
export const reducesendToManagement = (workflowItemStepId: number) => {
  return {
    type: MatchingQueueActionTypes.SEND_TO_MANAGEMENT,
    value: workflowItemStepId,
  };
};

export const setLoadingWorkflowSteps = (value: boolean) => {
  return {
    type: MatchingQueueActionTypes.LOADING_WORKFLOW_STEPS,
    value: value,
  };
};

export const setTotalWorkflowSteps = (value: number) => {
  return {
    type: MatchingQueueActionTypes.TOTAL_WORKFLOW_STEPS,
    value: value,
  };
};
